import register from '../../../../global/js/registry';
export default register('m-category-toggle-selector', () => import(/* webpackMode: "lazy" */ './m-category-toggle-selector.controller'));
